import React, {ReactNode} from 'react';
import { useTranslation } from 'react-i18next';
import { NewtonsCradle } from 'ldrs/react'
import 'ldrs/react/NewtonsCradle.css'

interface LoaderProps {
    image?: string | null;
    message?: string | ReactNode | null;
    useNeutralLoader?: boolean;
    brandingLogo?: string | null;
}

export default function Loader ({ image = null, message = null, useNeutralLoader = false, brandingLogo = null } : LoaderProps) {
    const { t } = useTranslation('common');
    const loadingAlt = t('states.loading');
    return (
        <div className="flex flex-col items-center justify-center w-full" style={{height: '50vh'}}>
            {message ? <p className="text-center text-gray-700" style={{marginBottom: '-90px', marginLeft: '30px'}}>{message}</p> : null}
            {image ? (
                <img src={image} className={'h-96'} alt={loadingAlt}/>
            ) : brandingLogo ? (
                <img
                    src={brandingLogo}
                    className={'max-w-[30%] h-auto animate-pulse-fade'}
                    alt={loadingAlt}
                />
            ) : useNeutralLoader ? (
                <NewtonsCradle
                    size="120"
                    speed="1.4"
                    color="black"
                />
            ) : (
                <img src="/images/logo.gif" className={'h-96'} alt={loadingAlt}/>
            )}
        </div>
    );
};
